//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import MemOutDetail from "./components/MemOutDetail";
import DefaultModal from "../../../component/popup/DefaultModal";

export default function MemOutDetailPage() {
    // 경고 모달
    const [completeModal, setCompleteModal] = useState(false);

    return (
        <>
            <MemOutDetail setCompleteModal={setCompleteModal} />

            {completeModal && <DefaultModal closeModal={() => setCompleteModal(false)} Simple={true} text="회원탈퇴가 완료되었습니다." goHome={true} />}
        </>
    );
}
